// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TEventCallback = (...args: any[]) => void

export type TEventCallbackParams = Parameters<TEventCallback>

const eventBus = {
  subscribers: {} as Record<string, TEventCallback[]>,

  subscribe(event: string, callback: TEventCallback): () => void {
    if (!this.subscribers[event]) {
      this.subscribers[event] = []
    }
    this.subscribers[event].push(callback)

    return () => this.unsubscribe(event, callback)
  },

  publish(event: string, ...data: TEventCallbackParams): void {
    if (!this.subscribers[event]) {
      return
    }

    this.subscribers[event].forEach(callback => {
      try {
        callback(...data)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Error in event handler for ${event}:`, error)
      }
    })
  },

  unsubscribe(event: string, callback: TEventCallback): void {
    if (!this.subscribers[event]) {
      return
    }

    this.subscribers[event] = this.subscribers[event].filter(
      cb => cb !== callback
    )
  },

  clear(event: string): void {
    delete this.subscribers[event]
  },

  clearAll(): void {
    this.subscribers = {}
  }
}

export default eventBus
